var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-icon-arrow-clockwise',{staticClass:"loading-float",attrs:{"font-scale":"2","animation":"spin"}})}
var staticRenderFns = []

export { render, staticRenderFns }